module.exports = __webpack_public_path__ + "img/newJD-upArrow.2fa83b63.svg";